let labels = [];

function matchMobileLabel(htmlFor) {
    let filter = labels.filter(label => label.htmlFor == htmlFor);
    return filter.length ? filter[0] : false;
}

function update() {
    // Only on Mobile label has display: block;
    let parent = this.parentNode;
    let label = this.nextSibling;
    if (parent && label && getComputedStyle(label).display == "block") {
        let active = matchMobileLabel(label.htmlFor);
        labels.forEach(label => {
            label.classList.remove("-active");
        });
        if (active) {
            active.classList.add("-active");
        }
        _gg.jump(parent, {
            offset: -65
        });
    }

    setTimeout(() => {
        let elements = document.querySelectorAll(".swiper-container");
        for (let i = 0; i < elements.length; i++) {
            try {
                elements[i].swiper.update(true);
                elements[i].swiper.slideTo(0);
            } catch (e) {}
        }
    }, 200);
}

_gg.domJsReady(() => {
    labels = Array.apply([], document.querySelectorAll("label.-mobile"));
    _gg.Gator(_gg.html).on("change", "input[name='license-tabs']", update);
});
